import axios from 'axios';

const inviteLabourer = async ({ email, fullName, dateOfBirth, onboardingDate, offboardingDate, requiredLicenses, requiredDocuments }) => {
  const { data: labourer } = await axios.post(`${process.env.REACT_APP_API_URL}/labourers/invite`, {
    email,
    fullName,
    dateOfBirth,
    onboardingDate,
    offboardingDate,
    requiredLicenses,
    requiredDocuments
  });

  return { labourer };
};

const getLabourers = async ({ page = 1, perPage = 10 }) => {
  const searchParams = new URLSearchParams();

  if (page) searchParams.append('page', page);
  if (perPage) searchParams.append('perPage', perPage);

  const { data: { labourers, count, pages } } = await axios.get(`${process.env.REACT_APP_API_URL}/labourers?${searchParams.toString()}`);

  return { labourers, count, pages };
};

const fetchLabourerByUserId = async (userId) => {
  const { data: labourer } = await axios.get(`${process.env.REACT_APP_API_URL}/labourers/by-user-id/${userId}`);

  return { labourer };
}

const updateLabourer = async ({ labourerId, updateData }) => {
  const { data: labourer } = await axios.put(`${process.env.REACT_APP_API_URL}/labourers/${labourerId}`, updateData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return { labourer };
}

const deleteLabourer = async (id) => {
  const { data: labourer } = await axios.delete(`${process.env.REACT_APP_API_URL}/labourers/${id}`);

  return { labourer };
}

const generateCredentials = async (labourerId) => {
  const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/labourers/${labourerId}/generate-credentials`);
  return data;
};

const downloadInfo = async (labourerId) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/labourers/${labourerId}/export`,
    { responseType: 'blob' }
  );
  return data;
};

const labourerService = {
  inviteLabourer,
  getLabourers,
  fetchLabourerByUserId,
  updateLabourer,
  deleteLabourer,
  generateCredentials,
  downloadInfo
};

export default labourerService;
